import store from '../store'

export function getMerchantData() {
  return store.getters['user/user'].data
}
